export default [
    {
        path: '/stok-yonetimi',
        name: 'stok-yonetimi',
        meta: { resource: 'admin|personel|tech' },
        component: () => import('../views/stock/list')
    },
    {
        path: '/depo-yonetimi',
        name: 'depo-yonetimi',
        meta: { resource: 'admin|personel|tech' },
        component: () => import('../views/stock/depo')
    },
    {
        path: '/urun-yonetimi',
        name: 'urun-yonetimi',
        meta: { resource: 'admin|personel|tech' },
        component: () => import('../views/stock/urun')
    }
]
  